/* ec-adv-packages.js — EstroClear advertorial package selector.
   Loaded as an external asset (CSP-safe) instead of inline.
   - Fills live per-market prices from /products/{handle}.js
   - BUY NOW: clear cart -> add this bundle -> go straight to /checkout.
     Buttons are <a href="/cart/{id}:1"> so they still work if JS never runs. */
(function () {
  function money(cents, cur) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function init() {
    var root = document.getElementById('ec-packages');
    if (!root || root.dataset.ecInit) return;
    root.dataset.ecInit = '1';

    var handle = root.getAttribute('data-product-handle');
    var buys = Array.prototype.slice.call(root.querySelectorAll('.ec-advpkg__buy'));
    var activeCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

    // 1) live variant ids + per-market prices
    if (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          buys.forEach(function (btn) {
            var idx = parseInt(btn.getAttribute('data-variant-index'), 10) - 1;
            var v = p.variants[idx];
            if (!v) return;
            btn.setAttribute('data-variant-id', v.id);
            btn.setAttribute('href', '/cart/' + v.id + ':1');
            var card = btn.closest('.ec-advpkg__card');
            var bottles = parseInt(btn.getAttribute('data-bottles'), 10) || 1;
            var perEl = card.querySelector('[data-per]');
            var totalEl = card.querySelector('[data-total]');
            var wasEl = card.querySelector('[data-was]');
            var instEl = card.querySelector('[data-install]');
            if (totalEl) totalEl.textContent = money(v.price, activeCur);
            if (perEl) perEl.textContent = money(Math.round(v.price / bottles), activeCur);
            if (wasEl && v.compare_at_price && v.compare_at_price > v.price) wasEl.textContent = money(v.compare_at_price, activeCur);
            if (instEl) instEl.textContent = 'or 4 interest-free payments of ' + money(Math.round(v.price / 4), activeCur);
          });
        })
        .catch(function () { /* keep fallback prices + hrefs */ });
    }

    // 2) BUY NOW navigation is handled by the plain <a href="/cart/{id}:1"> link —
    //    Shopify redirects a cart permalink straight to checkout. No click handler,
    //    nothing to intercept or fail. JS above only keeps the href + prices fresh.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
